module.exports = __webpack_public_path__ + "img/02_En.387ede01.png";